import { render } from "./ApprovalsDataTable.vue?vue&type=template&id=daf260c6"
import script from "./ApprovalsDataTable.vue?vue&type=script&lang=js"
export * from "./ApprovalsDataTable.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__